import { AbstractLogger } from './AbstractLogger';

export class SilentLogger extends AbstractLogger {
  public log(): void {}

  public error(): void {}

  public success(): void {}

  public info(): void {}

  public refreshContext(): void {}
}
